import {useEffect, useRef, useState} from 'react'

export const useDataTable = () => {
  const [sortingObj, setSortingObj] = useState({})
  const [searchArr, createSearchArray] = useState([])
  const [pageIndex, setPageIndex] = useState(0)

  const onPageIndexChange = pageIndex => {
    setPageIndex(pageIndex - 1)
  }
  const resetAllBtnClicked = () => {
    searchArrRef.current = []
  }
  // Convert from 0-based (internal) to 1-based (UI display)
  const getCurrentPage = () => {
    return pageIndex + 1
  }
  const searchArrRef = useRef([])

  const setSearchArry = (() => {
    let debounceTimer

    return searchObj => {
      if (searchObj.type === 'date') {
        const date = searchObj.value ? new Date(searchObj.value) : ''
        searchObj.value = date
          ? new Intl.DateTimeFormat('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
            }).format(date)
          : ''
      }

      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {
        const currentArr = searchArrRef.current
        const index = currentArr.findIndex(filter => filter.field === searchObj.field)

        let updatedArray
        if (!searchObj.value) {
          updatedArray =
            index !== -1 ? [...currentArr.slice(0, index), ...currentArr.slice(index + 1)] : [...currentArr]
        } else {
          updatedArray =
            index !== -1
              ? [...currentArr.slice(0, index), searchObj, ...currentArr.slice(index + 1)]
              : [...currentArr, searchObj]
        }

        // 🟢 Persist the latest filters
        searchArrRef.current = updatedArray

        setPageIndex(0)
        createSearchArray(updatedArray)
      }, 1000)
    }
  })()
  const setSearchArr = updatedArray => {
    createSearchArray(updatedArray) // 🔁 Persist new search array
    // Also trigger API/filter logic here if needed
  }
  useEffect(() => {}, [sortingObj, searchArr?.length, pageIndex])
  return {
    searchArr,
    sortingObj,
    pageIndex,
    setSortingObj,
    currentPage: getCurrentPage(),
    setSearchArry,
    setPageIndex,
    onPageIndexChange,
    createSearchArray,
    resetAllBtnClicked,
  }
}
